import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { ImportEmployeesModalLayout } from '../EmployeeModalLayout'

class ImportEmployees extends Component {
    constructor() {
        super()
        this.state = {
            isImportEmployeesModalOpened: false,
        }
    }
    opeImportEmployeesModal = () => {
        this.setState({ isImportEmployeesModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isImportEmployeesModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isImportEmployeesModalOpened) {
            modalComponent =
                <HBBModal>
                    <ImportEmployeesModalLayout
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}
                <button
                    className="btn btn-primary button-custom"
                     onClick={(e) => {
                        e.preventDefault()
                        this.opeImportEmployeesModal()
                    }}>
                    Import
                </button>
            </div>
        )
    }
}

export default ImportEmployees


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/ActionButtons/ImportEmployees.js